<script>
    import { Router, Link, Route } from "svelte-routing";
    import Assignment from "./addUpdate/addUpdateAssignment.html";
    import StudentsProgressList from './studentsProgress/studentsProgressList.html'

    import List from "./list/listAssignment.html";
    import { onMount } from "svelte";
    import MODULES from "../utils/modules.js" 
    import Forbidden from "../forbidden.html" 

    function init() {
    console.log("redirecting ");
    feather.replace();
  }
  onMount(init);

</script>

<Router>
    <Route path="">
        <List></List>
    </Route>
    <Route path="edit/:id" let:params>
        {#if MODULES.hasAccess(MODULES.VIEW_ASSIGNMENT)}
        <Assignment _id="{params.id}"></Assignment>

        {:else}
        <Forbidden />
        {/if}
    </Route>
    <Route path="/:assignmentId/assignmentprogress" let:params>
        {#if MODULES.hasAccess(MODULES.VIEW_ASSIGNMENT)}
        <StudentsProgressList assignmentId="{params.assignmentId}"></StudentsProgressList>

        {:else}
        <Forbidden />
        {/if}
    </Route>
</Router>